import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {WorkerKind} from "./WorkerKind";
import {Schema} from "@/common/Schema";

export class WorkerKey extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && v.valid() ? serialize(WorkerKey, v) : SKIP;
            },
            (v) => {
                return deserialize(WorkerKey, v);
            }
        );
    }

    constructor() {
        super();
        this._kind = null;
        this._level = 0;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
        this.validate();
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
        this.validate();
    }

    get label() {
        if (!this._kind || WorkerKind.isNone(this.kind)) {
            return "";
        } else if (this.level === 0) {
            return this.kind.name;
        } else {
            return this.kind.name + " (" + this.level + ")";
        }
    }

    validate() {
        if (this.kind && WorkerKind.isNone(this.kind) || WorkerKind.isSystem(this.kind)) {
            this._level = 0;
        }
    }

    equal(value) {
        if (value instanceof WorkerKey) {
            return this.kind.equal(value.kind) && this.level === value.level;
        }

        return false;
    }

    isNone() {
        return !this._kind || WorkerKind.isNone(this.kind);
    }

    valid() {

        if (!WorkerKind.is(this.kind) && !WorkerKind.isNone(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.level)) {
            return false;
        }

        return this.level >= 0;
    }

    copy() {
      return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorkerKey());
        } else if (target instanceof WorkerKey) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorkerKey, {
    _kind: alias("kind", WorkerKind.schema()),
    _level: alias("level", Schema.primitive())
});